import type {AllDocumentTypes} from '../../../types.generated'

export default (page: AllDocumentTypes, sliceType?: string) => {
  if (!sliceType) return page.data
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-ignore */

  const data = page.data.body.filter(
    ({slice_type}: {slice_type: string}) => slice_type === sliceType,
  )
  if (data.length === 1) return data[0]
  return data
}
